import { prefix, ajax } from './common';

export async function getServicersByZip(zip: string|number, distance = 30) {
  return await ajax({
    url: prefix + '/find-servicer/zip/' + zip,
    data: {
      distance
    },
  });
}

export async function getServicersByState(id: number) {
  return await ajax({
    url: prefix + '/find-servicer/state/' + id,
  });
}

export async function getSalesTaxRateByAddress(address) {
  return await ajax({
    url: prefix + '/address/sales-tax-rate',
    data: {
      address_line_1: address.address_line_1,
      city: address.city,
      state_id: address.state_id,
      postal_code: address.postal_code,
    }
  });
}